// @ts-nocheck
import { useContext } from "react";
import ReactDOM from "react-dom";
import { useState, useEffect } from "react";
// import { CompletedOrdersTab, WaitingOrdersTab } from "./Orders.tsx";
// import Report from "./Report";
import DefineProduct from "../adminPanelFields/DefineProduct";
import PanelFormatterHOC from "../adminPanelFields/PanelFormatterHOC";
import ShopSetting from "../adminPanelFields/shopSetting/ShopSetting";
// import ShopSetting from "./ShopSetting.tsx";
// import BasketMaker from "./BasketMaker";
import AdminOrdersContext, {
  AdminOrdersProvider
} from "../../../context/order/AdminOrdersContext.tsx";
// import OrderModal from "./OrderModal.tsx";
// import { connection } from "../../utils/apiConnection.ts";
import FinancialDepartment from "../adminPanelFields/transaction/Transactions.jsx";
// import WithAuthentication from "../../Authentication/AuthenticationContext";
import { useParams } from "react-router-dom";
// import UserContext from "context/UserContext";
// import AdminOrder from "./AdminOrders";
import Orders from "../../superAdminPanel/Orders/MainOrder.jsx";
// import OrdersSuperAdmin from "../Orders/OrdersSuperAdmin";
import OrdersSuperAdmin from "../../superAdminPanel/Orders/OrdersSuperAdmin.jsx";

export default function MainPanel({
  inputChangeHandler,
  inputFileHandler,
  changeHandler,
  otherInfo,
  setUpdater
}) {
  const [updateProduct, setUpdaterProduct] = useState(false);

  return (
    <>
      <div className="tab-content" id="pills-tabContent">
        <div
          className="tab-pane fade show active"
          id="pills-setting"
          role="tabpanel"
          aria-labelledby="pills-setting-tab"
        >
          <PanelFormatterHOC
            title={["تنظیمات"]}
            label="shopSetting"
            components={[
              <ShopSetting
                inputChangeHandler={inputChangeHandler}
                changeHandler={changeHandler}
                otherInfo={otherInfo}
                inputFileHandler={inputFileHandler}
                setUpdater={setUpdater}
              />
            ]}
          />
        </div>
        {/* </div> */}
        <div
          className="tab-pane fade"
          id="pills-define-product"
          role="tabpanel"
          aria-labelledby="pills-define-product-tab"
        >
          <PanelFormatterHOC
            title={["تعریف کالا"]}
            label="defineProduct"
            components={[
              <DefineProduct setUpdaterProduct={setUpdaterProduct} />
            ]}
          />
        </div>
        <div
          className="tab-pane fade"
          id="pills-orders"
          role="tabpanel"
          aria-labelledby="pills-orders-tab"
        >
          <PanelFormatterHOC
            title={[" سفارش"]}
            label="orders"
            components={[<OrdersSuperAdmin />]}
            // components={[<Orders />]}
          />
        </div>
        {/* <div
          className="tab-pane fade"
          id="pills-basket-maker"
          role="tabpanel"
          aria-labelledby="pills-basket-maker"
        >
          سبدساز
        </div> */}

        <div
          className="tab-pane fade"
          id="pills-finance"
          role="tabpanel"
          aria-labelledby="pills-finance"
        >
          <FinancialDepartment type={2} otherInfo={otherInfo} />
        </div>
      </div>
    </>
  );
}
